import { Banner } from '~/components/Layout/Banner'
import { useStalledChainIds } from '~/hooks/useChainHealth'
import { getChainLabel } from '~/utils/chainLabels'

export const ChainHealthBanner = () => {
  const stalled = useStalledChainIds()
  if (stalled.size === 0) return null

  const stalledIds = [...stalled]
  const names = stalledIds.map((id) => getChainLabel(id)).join(', ')

  return (
    <Banner>
      <span className="text-sm font-medium text-white">
        {stalled.size === 1
          ? `${names} is currently experiencing issues. Transactions may fail or be delayed, but all funds are safe.`
          : `${names} are currently experiencing issues. Transactions may fail or be delayed, but all funds are safe.`}
      </span>
    </Banner>
  )
}
